/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deep_Match_Top_Proof_PointsInputs */

const en_deep_match_top_proof_points = /** @type {(inputs: Deep_Match_Top_Proof_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top Proof Points`)
};

const de_deep_match_top_proof_points = /** @type {(inputs: Deep_Match_Top_Proof_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top Proof Points`)
};

const fr_deep_match_top_proof_points = /** @type {(inputs: Deep_Match_Top_Proof_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top Proof Points`)
};

const es_deep_match_top_proof_points = /** @type {(inputs: Deep_Match_Top_Proof_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top Proof Points`)
};

const it_deep_match_top_proof_points = /** @type {(inputs: Deep_Match_Top_Proof_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top Proof Points`)
};

const nl_deep_match_top_proof_points = /** @type {(inputs: Deep_Match_Top_Proof_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top Proof Points`)
};

const pl_deep_match_top_proof_points = /** @type {(inputs: Deep_Match_Top_Proof_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top Proof Points`)
};

const fi_deep_match_top_proof_points = /** @type {(inputs: Deep_Match_Top_Proof_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top Proof Points`)
};

const da_deep_match_top_proof_points = /** @type {(inputs: Deep_Match_Top_Proof_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top Proof Points`)
};

const sv_deep_match_top_proof_points = /** @type {(inputs: Deep_Match_Top_Proof_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top Proof Points`)
};

/**
* | output |
* | --- |
* | "Top Proof Points" |
*
* @param {Deep_Match_Top_Proof_PointsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const deep_match_top_proof_points = /** @type {((inputs?: Deep_Match_Top_Proof_PointsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deep_Match_Top_Proof_PointsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_deep_match_top_proof_points(inputs)
	if (locale === "fr") return fr_deep_match_top_proof_points(inputs)
	if (locale === "es") return es_deep_match_top_proof_points(inputs)
	if (locale === "it") return it_deep_match_top_proof_points(inputs)
	if (locale === "nl") return nl_deep_match_top_proof_points(inputs)
	if (locale === "pl") return pl_deep_match_top_proof_points(inputs)
	if (locale === "fi") return fi_deep_match_top_proof_points(inputs)
	if (locale === "da") return da_deep_match_top_proof_points(inputs)
	if (locale === "sv") return sv_deep_match_top_proof_points(inputs)
	return en_deep_match_top_proof_points(inputs)
});